
<template>

  <div>

    <div id="placeholder">
      <img src="/static/images/upload/upload-bleed.svg" class="svg">
    </div>

    <div class="upload-box">
      <div class="action-card">
        <h2>Upload Your Business Card Template</h2>

        <div class="error" v-if="error">{{error}}</div>
        <div class="uploader">
          <PdfUploader class="width-adjust" v-on="$listeners" :extra="extra" />
        </div>

        <p class="movie">
          <WistiaMovie asset="g7myk15el0">Watch movie
            <i class="fa fa-play-circle"></i> for file preparation tips</WistiaMovie>
        </p>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    'extra': {},
    error:{
      type:String,
      default:null
    }

  }
}
</script>

<style scoped>
.width-adjust{
  width:466px;
}

@media (max-width: 600px) {
  .width-adjust {
    width: 100%;
  }
}



#placeholder {
  /* width: 540px;
  height: 324px; */
  width:504px;
  background-color: $white;
  margin-bottom:30px;
}
/* #placeholder::before {
  content: '3.5" x 2"';
} */

p{
  line-height: 2px;
}


.upload-box{
  width:504px;
  margin: 1em 0;
}

@media (max-width: 600px) {
  #placeholder {
    width: 350px;
    height: 200px;
    background-color:$white;
    border: 6px dashed silver;
    color:#a0a0a0;
    line-height: 200px;
    font-size: 60px;
    text-align: center;
    margin:0 auto;
    transition: width .5s;

  }
 .upload-box{
    width:100%;
    margin: 1em 0;
}
}


.action-card {
  width: 100%;
  max-width: 100%;
  margin: 0;
}
.uploader {
  margin-top: 1em;
  margin-bottom: 0;
}

p.movie {
  text-align: center;
  font-size: 1rem;
  margin-top: 1em;
}

@media (max-width: 600px) {
  .action-card {
    width: 100%;
    max-width:350px;
    margin: 0 auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/pages/upload/UploaderBox.vue